import React, { Component } from 'react';
import logoAnbima from './img/logo-anbima.png';

export default class Header extends Component {

  parte1 = () => {
    return (
      <div>
        <h2>Sistema Financeiro Nacional e participantes do mercado</h2>
        <h3>Entenda como funciona o sistema financeiro brasileiro </h3>
      </div>
    );
  };
  parte2 = () => {
    return (
      <div>
        <h2>Ética, regulamentação e análise do perfil do investidor</h2>
        <h3>
          Entenda as principais regras que devem ser seguidas pelo profissional da
          intermediação financeira
        </h3>
      </div>
    );
  };
  parte3 = () => {
    return (
      <div>
        <h2>Conceitos básicos de economia e finanças</h2>
        <h3>
          Compreenda o funcionamento do mercado a partir do estudo de seus
          principais conceitos
        </h3>
      </div>
    );
  };
  parte4 = () => {
    return (
      <div>
        <h2>Princípios de investimento</h2>
        <h3>
          Aprenda os principais conceitos dos agentes econômicos e
          as características dos ativos
        </h3>
      </div>
    );
  };
  parte5 = () => {
    return (
      <div>
        <h2>Fundos de investimento</h2>
        <h3>
          Conheça os conceitos e as características de um dos principais produtos
          de investimento do país
        </h3>
      </div>
    );
  };
  parte6 = () => {
    return (
      <div>
        <h2>Instrumentos de renda variável e renda fixa</h2>
        <h3>
          Conheça os conceitos e as características desses ativos no mercado
          nacional
        </h3>
      </div>
    );
  };
  parte7 = () => {
    return (
      <div>
        <h2>Previdência complementar aberta: PGBL e VGBL</h2>
        <h3>
          Conheça a previdência complementar no brasil e seus principais
          conceitos
        </h3>
      </div>
    );
  };



  header = () =>{

    switch(this.props.path){
      case '/sistema-financeiro': return <this.parte1/>;

      case '/analise-do-perfil-investidor': return <this.parte2/>;

      case '/conceitos-basicos-economia-financas': return <this.parte3/>;

      case '/principios-de-investimento': return <this.parte4/>;

      case '/fundos-de-investimento': return <this.parte5/>;

      case '/renda-variavel-fixa': return <this.parte6/>;

      case '/previdencia': return <this.parte7/>;
      default:
    }
}

  render() {
    return (

      <header>
      <div className="container">
      <h1><a href="http://www.anbima.com.br" target="_blank" rel="noopener noreferrer"><img src={logoAnbima} alt="Anbima"/></a></h1>
      <h3> Material oficial de estudos - CPA-10 </h3>
      <this.header/>
      </div>
      </header>

    );
  }
}



// WEBPACK FOOTER //
// ./src/Header.js